// Application configuration.
//
// Values come from `window.__ENV__`, written into `env.js` by the container
// entrypoint at start up (see generate-env-js.sh). That keeps the built image
// free of environment specific values, so the same image runs anywhere.
//
// The `process.env` fallback is what makes `npm start` work: in development
// `public/env.js` is an empty stub and Create React App loads `.env` instead.
// The `process.env.REACT_APP_*` reads must stay written out literally, since
// Create React App replaces them textually at build time.

const runtime = (typeof window !== 'undefined' && window.__ENV__) || {}

function read(runtimeValue, buildTimeValue) {
  return runtimeValue || buildTimeValue || ''
}

export const config = {
  apiBaseUrl: read(runtime.REACT_APP_API_BASE_URL, process.env.REACT_APP_API_BASE_URL),
  recaptchaPublicKey: read(runtime.REACT_APP_RECAPTCHA_PUBLIC_KEY, process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY),
  cookieDomain: read(runtime.REACT_APP_COOKIE_DOMAIN, process.env.REACT_APP_COOKIE_DOMAIN),
  pagesUrl: read(runtime.REACT_APP_PAGES_URL, process.env.REACT_APP_PAGES_URL),
  baseUrl: read(runtime.REACT_APP_BASE_URL, process.env.REACT_APP_BASE_URL),
  googleApiToken: read(runtime.REACT_APP_GOOGLE_API_TOKEN, process.env.REACT_APP_GOOGLE_API_TOKEN),
  appleApiToken: read(runtime.REACT_APP_APPLE_API_TOKEN, process.env.REACT_APP_APPLE_API_TOKEN),
  appleRedirectUri: read(runtime.REACT_APP_APPLE_REDIRECT_URI, process.env.REACT_APP_APPLE_REDIRECT_URI)
}

export default config
